import styled, { css } from "styled-components";
import avatarPlaceholder from "./assets/avatar-placeholder.svg";

export default styled.div`
  ${({ photo }) =>
    (photo
      ? css`
          background: url(${photo}) no-repeat center / cover;
        `
      : css`
          background: url(${avatarPlaceholder}) no-repeat center;
        `)} );
  background-color: rgb(174, 174, 174);
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;



// WEBPACK FOOTER //
// ./src/components/AsapAvatar.js